import { privateApi, privateApiWithBlob } from "../api/axios";
import { EventData, EventUpdate } from "../interfaces/events";

export const postEvent = async (data : EventData) => {
    try {
        const response = await privateApi.post(`api/events`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getEvents = async () => {
    try {
        const response = await privateApi.get(`api/events`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateEvent = async (id : number, data : EventUpdate) => {
    try {
        const response = await privateApi.patch(`api/events/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteEvent = async (id : number) => {
    try {
        const response = await privateApi.delete(`api/events/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getEvent = async (id : number) => {
    try {
        const response = await privateApi.get(`api/events/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const postHolidayRequest = async (data : any) => {
    try {
        const response = await privateApi.post(`api/events/request`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

// Uniquement pour les managers / editeurs
export const getHolidayRequests = async () => {
    try {
        const response = await privateApi.get(`api/events/unvalidated`);
        return response;
    } catch (error) {
        throw error;
    }
}

// Uniquement pour admins / directions
export const getHolidayRequestsValidatedNotSent = async () => {
    try {
        const response = await privateApi.get(`api/events/validated-not-sent`);
        return response;
    } catch (error) {
        throw error;
    }
}

// Uniquement pour managers / editeurs
export const validateNotSendHolidays = async (ids: number[]) => {
    try {
        const response = await privateApi.post(`api/events/validate`, { idsEvents: ids });
        return response;
    } catch (error) {
        throw error;
    }
}

// Uniquement pour les admins / directions
export const sendEmailHolidays = async (ids: number[]) => {
    try {
        const response = await privateApi.post(`api/events/send-email`, { idsEvents: ids });
        return response;
    } catch (error) {
        throw error;
    }
}

// Update d'un evenement
export const updateHolidayRequest = async (id : number, data : any) => {
    try {
        const response = await privateApi.patch(`api/events/request/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

// Delete d'un evenement
export const deleteHolidayRequest = async (id : number) => {
    try {
        const response = await privateApi.delete(`api/events/request/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const refuseHolidayRequest = async (ids: number[]) => {
    try {
        const response = await privateApi.post(`api/events/refuse`, { idsEvents: ids });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getEventsSageExport = async (startDate: string, endDate: string) => {
    try {
        const response = await privateApiWithBlob.get(`api/events/sage-export?startDate=${startDate}&endDate=${endDate}`, { responseType: "blob" });
        return response;
    } catch (error) {
        throw error;
    }
}